import { useTranslation } from "react-i18next";

import { getLangParams } from "../../../../utils/helpers";

import { IconSprite } from "../../../ui/IconSprite/IconSprite";

import {
  BoxIcon,
  CardContentStyled,
  CardStyled,
  StyledLink,
  Text,
  Title,
} from "./SimpleCard.styled";

export const SimpleCard = ({
  title,
  desc,
  icon,
  iconShow = false,
  link,
  index = 2, //default white card
  children,
  addStyles,
  type,
  blog,
  description,
  getshorter,
  ...rest
}) => {
  const { t } = useTranslation();
  const lang = getLangParams();

  // todo EnUm
  const colorOptions = {
    background: ["#0C0C0E", "#d4fe75", "#FFFFFF"],
    iconCircle: ["#82818e", "#f2ffd7", "#f7f7f8"],
    text: ["#fff", "#000", "#000"],
    secondaryText: ["#A9A9A9", "#54535D", "#54535D"],
    buttonBackground: ["rgba(255, 255, 255, 0.32)", "#F2FFD7", "#F6F6F6"],
    buttonHover: ["rgba(255, 255, 255, 0.56)", "#9EEB00", "#E6E6E6"],
    buttonActive: ["rgba(255, 255, 255, 0.72)", "#7CB800", "#CCC"],
    buttonText: ["#fff", "#000", "#000"],
  };

  const cardBackground = colorOptions.background[index % 3] || "";
  const iconBackground = colorOptions.iconCircle[index % 3] || "";
  const titleColor = colorOptions.text[index % 3] || "";
  const descriptionColor = colorOptions.secondaryText[index % 3] || "";
  const buttonBackground = colorOptions.buttonBackground[index % 3] || "";
  const buttonColor = colorOptions.buttonText[index % 3] || "";
  const buttonHover = colorOptions.buttonHover[index % 3] || "";
  const buttonActive = colorOptions.buttonActive[index % 3] || "";

  return (
    <CardStyled cardBackground={cardBackground} addStyles={addStyles} {...rest}>
      <CardContentStyled {...rest}>
        {iconShow && (
          <BoxIcon iconBackground={iconBackground}>
            <IconSprite tag={icon} width="28" height="28" />
          </BoxIcon>
        )}

        <Title
          getshorter={getshorter}
          className="card-title"
          titleColor={titleColor}
          {...rest}
        >
          {title}
        </Title>

        <Text descriptionColor={descriptionColor}>{desc || description}</Text>

        {link && (
          <StyledLink
            to={`/${lang}blog/${link}/`}
            blog={+blog}
            buttoncolor={buttonColor}
            buttonbackground={buttonBackground}
            buttonhover={buttonHover}
            buttonactive={buttonActive}
          >
            <IconSprite tag={"eys"} width="20" height="21" />

            {blog ? t("blog.sliderButton") : t("global.view")}
          </StyledLink>
        )}
      </CardContentStyled>
    </CardStyled>
  );
};
